<template>
    <el-main ref="mainContent">
        <!-- 统计概览 -->
        <div class="summary-row">
            <el-card shadow="always" class="summary-card">
                <div class="summary-num">{{ summary.userCount || 0 }}</div>
                <div class="summary-label">注册用户</div>
            </el-card>
            <el-card shadow="always" class="summary-card success">
                <div class="summary-num">{{ summary.onlines || 0 }}</div>
                <div class="summary-label">在线用户</div>
            </el-card>
            <el-card shadow="always" class="summary-card primary">
                <div class="summary-num">{{ summary.vipCount || 0 }}</div>
                <div class="summary-label">会员数量</div>
            </el-card>
            <el-card shadow="always" class="summary-card warn">
                <div class="summary-num">{{ summary.orderCount || 0 }}</div>
                <div class="summary-label">总订单数</div>
            </el-card>
            <el-card shadow="always" class="summary-card danger">
                <div class="summary-num">{{ summary.totalCredits || 0 }}</div>
                <div class="summary-label">红豆余量</div>
            </el-card>            
            <el-card shadow="always" class="summary-card success">
                <div class="summary-num">{{ summary.totalFee | fenToYuan(0) }}</div>
                <div class="summary-label">累计收入</div>
            </el-card>
        </div>

        <!-- 图表区域：左右两列布局 -->
        <div class="echarts">
            <!-- 左列：合并饼图 + 年龄分布 -->
            <div class="chart-col chart-col-left">
                <el-card>
                    <div class="echart" ref="chart_dist"></div>
                </el-card>

                <el-card header="用户年龄分布">
                    <div class="echart" ref="chart_age"></div>
                </el-card>
            </div>

            <!-- 右列：用户趋势 + 支付趋势 + 用户区域分布 -->
            <div class="chart-col chart-col-right">
                <el-card>
                    <div slot="header" class="trend-header">
                        <span class="trend-title">用户趋势</span>
                        <el-date-picker v-model="trendRange" type="monthrange" size="mini" unlink-panels
                            range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
                            value-format="yyyy-MM" :clearable="false" style="width: 220px" @change="loadTrend" />
                    </div>
                    <div class="echart" ref="chart_userTrend"></div>
                </el-card>

                <el-card header="支付趋势">
                    <div class="echart" ref="chart_paymentTrend"></div>
                </el-card>

                <el-card header="用户区域分布">
                    <div class="echart" ref="chart_region"></div>
                </el-card>
            </div>
        </div>
    </el-main>
</template>

<script>
    import {
        httpRequest
    } from '@/utils/app';

    const echarts = require('echarts')
// ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc']
    // 婚恋玫红主题图表配色：同色系不同明度/色相，兼顾区分度与整体协调，避免默认蓝绿橙与主题割裂
    const CHART_COLORS = {
        primary: '#ee6666', 
        deep: '#9a60b4', 
        soft: '#73c0de', 
        mauve: '#5470c6', 
        coral: '#fc8452', 
        peach: '#fac858', 
        green: '#67c23a', 
        gray: '#c0c4cc'
    }

    // 由主题色生成折线图面积渐变（顶部半透明 → 底部近透明）
    const areaGradient = (hex, topAlpha = 0.3, bottomAlpha = 0.02) => {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: `rgba(${r},${g},${b},${topAlpha})`
            },
            {
                offset: 1,
                color: `rgba(${r},${g},${b},${bottomAlpha})`
            }
        ])
    }

    export default {
        data() {
            return {
                summary: {},
                charts: [],
                // 用户趋势月份区间，默认当前月
                trendRange: []
            }
        },
        mounted() {
            // 默认当前月
            const now = new Date()
            const ym = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0')
            this.trendRange = [ym, ym]

            this.loadData()
            this.loadTrend()
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
            this.charts.forEach(c => c && c.dispose())
        },
        methods: {
            loadData() {
                httpRequest({
                    action: 'counter_stats'
                }).then(res => {
                    if (res.error === false) {
                        const d = res.data
                        this.summary = d.summary || {}
                        this.$nextTick(() => {
                            this.renderCharts(d)
                        })
                    }
                })
            },

            /** 加载趋势数据（按月份区间查询 ca_counter） */
            loadTrend() {
                if (!this.trendRange || this.trendRange.length !== 2) return
                const startYM = this.trendRange[0]
                const endYM = this.trendRange[1]

                // 起始月首日 00:00:00 ~ 结束月末日 23:59:59（秒级时间戳）
                const startDate = new Date(startYM + '-01T00:00:00')
                const endDate = new Date(endYM + '-01T00:00:00')
                endDate.setMonth(endDate.getMonth() + 1)
                endDate.setDate(endDate.getDate() - 1)
                endDate.setHours(23, 59, 59)
                const start = Math.floor(startDate.getTime() / 1000)
                const end = Math.floor(endDate.getTime() / 1000)

                httpRequest({
                    action: 'counter_lists',
                    start: start,
                    end: end
                }, 'GET').then(res => {
                    if (res.error === false) {
                        this.renderTrend(res.data || [], startYM, endYM)
                    }
                })
            },

            /** 按天/月聚合 counter 数据并渲染两张趋势图（四维度） */
            renderTrend(rows, startYM, endYM) {
                // 起始月与结束月相同则按天展示，跨月则按月展示
                const byDay = startYM === endYM

                // 将每条记录按 dateline(秒) 归入对应 bucket 并累加
                const bucketMap = {}
                rows.forEach(r => {
                    const d = new Date(Number(r.dateline) * 1000)
                    const key = this.fmtDate(d, byDay ? 'day' : 'month')
                    if (!bucketMap[key]) bucketMap[key] = {
                        regists: 0,
                        logins: 0,
                        vip: 0,
                        credits: 0
                    }
                    bucketMap[key].regists += Number(r.regists) || 0
                    bucketMap[key].logins += Number(r.logins) || 0
                    // ca_counter 字段命名规范：_fee=金额（分），_deal=交易笔数
                    bucketMap[key].vip += Number(r.vip_fee) || 0
                    bucketMap[key].credits += Number(r.credits_fee) || 0
                })

                const labels = this.buildLabels(startYM, endYM, byDay)
                const regists = [],
                    logins = [],
                    vip = [],
                    credits = []
                labels.forEach(k => {
                    const rec = bucketMap[k] || {
                        regists: 0,
                        logins: 0,
                        vip: 0,
                        credits: 0
                    }
                    regists.push(rec.regists)
                    logins.push(rec.logins)
                    vip.push(rec.vip)
                    credits.push(rec.credits)
                })

                this.renderUserTrend({
                    labels: labels,
                    regists: regists,
                    logins: logins
                })
                this.renderPaymentTrend({
                    labels: labels,
                    vip: vip,
                    credits: credits
                })
                this.resizeAll()
            },

            /** 生成连续的 bucket 标签：按天或按月，且不超过今天/当前月 */
            buildLabels(startYM, endYM, byDay) {
                const labels = []
                const now = new Date()
                const todayKey = this.fmtDate(now, 'day')
                const curMonth = this.fmtDate(now, 'month')

                if (byDay) {
                    const d = new Date(startYM + '-01T00:00:00')
                    const month = d.getMonth()
                    while (d.getMonth() === month) {
                        const key = this.fmtDate(d, 'day')
                        if (key > todayKey) break
                        labels.push(key)
                        d.setDate(d.getDate() + 1)
                    }
                } else {
                    const d = new Date(startYM + '-01T00:00:00')
                    const end = new Date(endYM + '-01T00:00:00')
                    while (d.getTime() <= end.getTime()) {
                        const key = this.fmtDate(d, 'month')
                        if (key > curMonth) break
                        labels.push(key)
                        d.setMonth(d.getMonth() + 1)
                    }
                }
                return labels
            },

            /** 日期格式化：day=yyyy-MM-dd, month=yyyy-MM */
            fmtDate(d, type) {
                const y = d.getFullYear()
                const m = String(d.getMonth() + 1).padStart(2, '0')
                if (type === 'month') return y + '-' + m
                return y + '-' + m + '-' + String(d.getDate()).padStart(2, '0')
            },

            /** 渲染静态图表（饼图/柱状图），趋势图由 loadTrend 独立驱动 */
            renderCharts(d) {
                this.renderDist(d.paymentDist || [], d.genderDist || [])
                this.renderProvince(d.provinceDist || [])
                this.renderAge(d.ageDist || [])
                this.resizeAll()
            },

            /** 布局就绪后统一重算所有图表尺寸 */
            resizeAll() {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.charts.forEach(c => c && c.resize())
                    })
                })
            },

            initChart(ref) {
                const dom = this.$refs[ref]
                if (!dom) return null
                // 复用已存在实例，避免趋势图与静态图相互 dispose
                let chart = echarts.getInstanceByDom(dom)
                if (!chart) {
                    chart = echarts.init(dom)
                    this.charts.push(chart)
                }
                return chart
            },

            // ---------- 图表1：支付费用 + 用户性别（双饼合一） ----------
            renderDist(paymentRows, genderRows) {
                const chart = this.initChart('chart_dist')
                if (!chart) return

                const paymentData = paymentRows.map(r => ({
                    name: r.type == 1 ? 'VIP会员' : '红豆充值',
                    value: Number(r.totalFee) / 100,
                    itemStyle: {
                        color: r.type == 1 ? CHART_COLORS.primary : CHART_COLORS.peach
                    }
                }))

                const genderMap = {
                    0: '未知',
                    1: '男',
                    2: '女'
                }
                const genderColors = {
                    1: CHART_COLORS.mauve, // 男
                    2: CHART_COLORS.deep, // 女
                    0: CHART_COLORS.gray // 未知
                }
                const genderData = genderRows.map(r => ({
                    name: genderMap[r.gender] || '未知',
                    value: Number(r.cnt),
                    itemStyle: {
                        color: genderColors[r.gender] || CHART_COLORS.gray
                    }
                }))

                const emptyPie = [{
                    name: '暂无数据',
                    value: 0
                }]
                chart.setOption({
                    // 左右结构、上下错开：左饼置上、右饼置下，各自加标题区分
                    title: [{
                            text: '支付费用',
                            left: '25%',
                            top: '0%',
                            textAlign: 'center',
                            textStyle: {
                                fontSize: 13,
                                color: '#606266',
                                fontWeight: 'normal'
                            }
                        },
                        {
                            text: '用户性别',
                            left: '72%',
                            bottom: '0%',
                            textAlign: 'center',
                            textStyle: {
                                fontSize: 13,
                                color: '#606266',
                                fontWeight: 'normal'
                            }
                        }
                    ],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: [{
                            name: '支付费用分布',
                            type: 'pie',
                            radius: ['30%', '50%'],
                            center: ['25%', '40%'],
                            label: {
                                formatter: '{b}\n{c}元'
                            },
                            data: paymentData.length ? paymentData : emptyPie
                        },
                        {
                            name: '用户性别分布',
                            type: 'pie',
                            radius: ['30%', '50%'],
                            center: ['75%', '60%'],
                            label: {
                                formatter: '{b}\n{c}人'
                            },
                            data: genderData.length ? genderData : emptyPie
                        }
                    ]
                })
            },

            // ---------- 图表2：用户区域分布（纵向柱状图） ----------
            renderProvince(rows) {
                const chart = this.initChart('chart_region')
                if (!chart) return

                // 后端已按人数降序返回，纵向柱状图从左到右即为排行顺序
                const names = rows.map(r => r.province)
                const values = rows.map(r => Number(r.cnt))

                chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter: '{b}: {c}人'
                    },
                    grid: {
                        left: 20,
                        right: 20,
                        top: 30,
                        bottom: 10,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: names.length ? names : ['暂无数据'],
                        axisLabel: {
                            interval: 0,
                            rotate: 40,
                            fontSize: 11
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        type: 'bar',
                        data: values,
                        barMaxWidth: 24,
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}',
                            color: '#909399',
                            fontSize: 12
                        },
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                            color: areaGradient(CHART_COLORS.mauve,1)
                        }
                    }]
                })
            },

            // ---------- 图表3：用户年龄分布（横向柱状图） ----------
            renderAge(rows) {
                const chart = this.initChart('chart_age')
                if (!chart) return

                const buckets = []
                const maleMap = {},
                    femaleMap = {}
                rows.forEach(r => {
                    const start = Number(r.ageStart)
                    const label = start + '-' + (start + 4)
                    if (!buckets.includes(label)) buckets.push(label)
                    if (r.gender == 1) maleMap[label] = Number(r.cnt)
                    else if (r.gender == 2) femaleMap[label] = Number(r.cnt)
                })
                buckets.sort((a, b) => parseInt(a) - parseInt(b))

                chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter(params) {
                            let html = params[0].axisValue + '岁<br/>'
                            params.forEach(p => {
                                html += p.marker + p.seriesName + ': ' + p.value + '人<br/>'
                            })
                            return html
                        }
                    },
                    legend: {
                        data: ['男', '女'],
                        top: 0,
                        right: 10,
                        itemWidth: 14,
                        itemHeight: 10,
                        itemGap: 12,
                        textStyle: {
                            fontSize: 12
                        }
                    },
                    grid: {
                        left: 20,
                        right: 30,
                        top: 40,
                        bottom: 20,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value'
                    },
                    yAxis: {
                        type: 'category',
                        data: buckets,
                        inverse: true
                    },
                    series: [{
                            name: '男',
                            type: 'bar',
                            data: buckets.map(b => maleMap[b] || 0),
                            itemStyle: {
                                color: CHART_COLORS.mauve
                            }
                        },
                        {
                            name: '女',
                            type: 'bar',
                            data: buckets.map(b => femaleMap[b] || 0),
                            itemStyle: {
                                color: CHART_COLORS.deep
                            }
                        }
                    ]
                })
            },

            // ---------- 图表4：用户趋势（折线图） ----------
            renderUserTrend(d) {
                const chart = this.initChart('chart_userTrend')
                if (!chart) return

                const labels = d.labels || []
                chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        formatter(params) {
                            let html = params[0].axisValue + '<br/>'
                            params.forEach(p => {
                                html += p.marker + p.seriesName + ': ' + p.value + '人<br/>'
                            })
                            return html
                        }
                    },
                    legend: {
                        data: ['注册', '活跃'],
                        top: 0,
                        right: 10,
                        itemWidth: 14,
                        itemHeight: 10,
                        itemGap: 12,
                        textStyle: {
                            fontSize: 12
                        }
                    },
                    grid: {
                        left: 40,
                        right: 30,
                        bottom: 20,
                        top: 40
                    },
                    xAxis: {
                        type: 'category',
                        data: labels,
                        boundaryGap: false,
                        axisLabel: {
                            formatter(value) {
                                return value.slice(5)
                            }
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                            name: '注册',
                            type: 'line',
                            smooth: true,
                            data: (d.regists || []).map(Number),
                            lineStyle: {
                                color: CHART_COLORS.deep,
                                width: 2
                            },
                            itemStyle: {
                                color: CHART_COLORS.deep
                            },
                            areaStyle: {
                                color: areaGradient(CHART_COLORS.deep)
                            }
                        },
                        {
                            name: '活跃',
                            type: 'line',
                            smooth: true,
                            data: (d.logins || []).map(Number),
                            lineStyle: {
                                color: CHART_COLORS.green,
                                width: 2
                            },
                            itemStyle: {
                                color: CHART_COLORS.green
                            },
                            areaStyle: {
                                color: areaGradient(CHART_COLORS.green)
                            }
                        }
                    ]
                })
            },

            // ---------- 图表5：支付趋势（折线图） ----------
            renderPaymentTrend(d) {
                const chart = this.initChart('chart_paymentTrend')
                if (!chart) return

                const labels = d.labels || []
                chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        formatter(params) {
                            let html = params[0].axisValue + '<br/>'
                            params.forEach(p => {
                                const val = (Number(p.value) / 100).toFixed(2)
                                html += p.marker + p.seriesName + ': ' + val + '元<br/>'
                            })
                            return html
                        }
                    },
                    legend: {
                        data: ['VIP会员', '红豆充值'],
                        top: 0,
                        right: 10,
                        itemWidth: 14,
                        itemHeight: 10,
                        itemGap: 12,
                        textStyle: {
                            fontSize: 12
                        }
                    },
                    grid: {
                        left: 40,
                        right: 30,
                        bottom: 20,
                        top: 40
                    },
                    xAxis: {
                        type: 'category',
                        data: labels,
                        boundaryGap: false,
                        axisLabel: {
                            formatter(value) {
                                return value.slice(5)
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter(value) {
                                return (value / 100).toFixed(0)
                            }
                        }
                    },
                    series: [{
                            name: 'VIP会员',
                            type: 'line',
                            smooth: true,
                            data: (d.vip || []).map(Number),
                            lineStyle: {
                                color: CHART_COLORS.primary,
                                width: 2
                            },
                            itemStyle: {
                                color: CHART_COLORS.primary
                            },
                            areaStyle: {
                                color: areaGradient(CHART_COLORS.primary)
                            }
                        },
                        {
                            name: '红豆充值',
                            type: 'line',
                            smooth: true,
                            data: (d.credits || []).map(Number),
                            lineStyle: {
                                color: CHART_COLORS.peach,
                                width: 2
                            },
                            itemStyle: {
                                color: CHART_COLORS.peach
                            },
                            areaStyle: {
                                color: areaGradient(CHART_COLORS.peach)
                            }
                        }
                    ]
                })
            },

            handleResize() {
                this.charts.forEach(c => c && c.resize())
            }
        }
    }
</script>

<style scoped>
    /* 页面级：flex纵向布局铺满全屏，禁止滚动条 */
    .el-main {
        display: flex !important;
        flex-direction: column;
        height: 100%;
        overflow: hidden !important;
        padding: 15px;
        box-sizing: border-box;
    }

    .summary-row {
        flex-shrink: 0;
        display: flex;
        gap: 15px;
        margin-bottom: 15px;
    }

    .summary-row .summary-card {
        flex: 1;
        min-width: 0;
    }

    /* 概览卡片固定高度 */
    .summary-card {
        text-align: center;
        cursor: default;
        height: 90px;
    }

    .summary-card>>>.el-card__body {
        padding: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        box-sizing: border-box;
    }

    .summary-num {
        font-family: 'DigifaceWide';
        font-size: 28px;
        font-weight: bold;
        color: #626262;
        line-height: 1.4;
    }

    .summary-card.warn .summary-num {
        color: #c76ba8;
    }

    .summary-card.success .summary-num {
        color: #55aa00;
    }

    .summary-card.primary .summary-num {
        color: #db346e;
    }

    .summary-card.danger .summary-num {
        color: #faa161;
    }

    .summary-label {
        font-size: 13px;
        color: #909399;
        margin-top: 4px;
    }

    /* 图表区域：左右两列布局 */
    .echarts {
        flex: 1;
        display: flex;
        flex-direction: row;
        gap: 15px;
        min-height: 0;
    }

    /* 列容器：垂直 flex，列内卡片等高填充 */
    .chart-col {
        display: flex;
        flex-direction: column;
        gap: 15px;
        min-width: 0;
        min-height: 0;
    }

    /* 左列右边缘与「会员数量」KPI 卡片（第 2 张）右边缘对齐：
       2 张等宽卡片 + 1 个 15px 间距 = 2×(100%-60px)/5 + 15px = 40% - 9px */
    .chart-col-left {
        flex: 0 0 calc(40% - 9px);
    }

    /* 右列占据剩余宽度 */
    .chart-col-right {
        flex: 1;
    }

    /* 卡片通用：列内等分高度 + 内部纵向布局 */
    .chart-col .el-card {
        flex: 1;
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* 左列：性别支付概览占 1/3 高，年龄分布占 2/3 高 */
    .chart-col-left .el-card:first-child {
        flex: 1;
    }

    .chart-col-left .el-card:last-child {
        flex: 2;
    }

    .echarts .el-card>>>.el-card__header {
        flex-shrink: 0;
        padding: 10px 15px;
        font-size: 14px;
        font-weight: 600;
    }

    /* 用户趋势标题栏：标题左、月份区间选择器右 */
    .trend-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .trend-header .trend-title {
        font-size: 14px;
        font-weight: 600;
    }

    .echarts .el-card>>>.el-card__body {
        flex: 1;
        min-height: 0;
        padding: 10px;
        display: flex;
    }

    /* echarts 容器填满 card body */
    .echart {
        width: 100%;
        height: 100%;
        flex: 1;
        min-height: 0;
    }
</style>